import React from 'react'

function DashBoard() {
    return <div>Hello From DashBoard</div>;
}

export default DashBoard
